/** Fixed Δp margin preview (matches backend ``marginate_probability_fixed_pp``). */

export function parseProbMarginInput(raw, label = 'Margin') {
  const s = String(raw ?? '').trim();
  if (s === '') return null;
  const v = parseFloat(s);
  if (!Number.isFinite(v) || v < 0 || v > 0.5) {
    throw new Error(`${label} must be between 0 and 0.5 (probability vs fair), or blank for auto.`);
  }
  return v;
}

function clampProb(v) {
  return Math.max(1e-6, Math.min(1 - 1e-6, v));
}

/** Implied probability after fixed Δp, clamped to [floor, ceiling] vs fair (same as logit path). */
export function previewFixedMarginImplied(
  pFair,
  probMarginPp,
  marginFloor = 0.05,
  marginCeiling = 0.15
) {
  const p = Number(pFair);
  const m = Number(probMarginPp);
  const floor = Number.isFinite(Number(marginFloor)) ? Number(marginFloor) : 0.05;
  const ceiling = Number.isFinite(Number(marginCeiling)) ? Number(marginCeiling) : 0.15;
  if (!Number.isFinite(p) || !Number.isFinite(m)) return null;
  const pc = clampProb(p);
  const raw = pc + m;
  return clampProb(Math.max(floor + pc, Math.min(ceiling + pc, raw)));
}

export function previewFixedMarginEffectiveDelta(
  pFair,
  probMarginPp,
  marginFloor = 0.05,
  marginCeiling = 0.15
) {
  const implied = previewFixedMarginImplied(pFair, probMarginPp, marginFloor, marginCeiling);
  const p = Number(pFair);
  if (implied == null || !Number.isFinite(p)) return null;
  return implied - clampProb(p);
}

export function previewFixedMarginDecimal(
  pFair,
  probMarginPp,
  marginFloor = 0.05,
  marginCeiling = 0.15
) {
  const implied = previewFixedMarginImplied(pFair, probMarginPp, marginFloor, marginCeiling);
  if (implied == null || implied <= 0) return null;
  const dec = 1 / implied;
  return Number.isFinite(dec) && dec > 0 ? dec : null;
}

export function quoteMarginationClamps(quote) {
  const floor = Number(quote?.margination_floor);
  const ceiling = Number(quote?.margination_ceiling);
  return {
    floor: Number.isFinite(floor) ? floor : 0.05,
    ceiling: Number.isFinite(ceiling) ? ceiling : 0.15,
  };
}
